import type { Branch } from './nodes'
export default {
  12: (): Branch => {
    return {
      type: 'BranchOption',
      title: '请问你对本次杂货OEM的初步需求是怎样的？',
      key: 'groceriesQuestionInitialRequirement',
      options: [
        {
          label: '根据图片或样品，帮我生产出一模一样的产品。（包含加Logo）',
          value: 'A',
          next: '121'
        },
        {
          label:
            '在既成品的基础上，我有一些改良的需求 。（包括颜色、材质、 功能、尺寸、设计等的改良）',
          value: 'B',
          next: '121'
        },
        {
          label: '我需要定制全新的产品，目前市场上没有既成品可参考。',
          value: 'C',
          tooltip:
            '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务',
          next: '6',
          bridge: 'B'
        }
      ],
      long: true
    }
  },
  121: (prev: any, data: any): any => {
    const options =
      data.groceriesQuestionInitialRequirement === 'A'
        ? [
          {
            next: '3',
            bridge: 'B'
          },
          { next: '1211' }
        ]
        : [
          {
            next: '3',
            bridge: '5'
          },
          {
            next: '5'
          }
        ]
    return {
      type: 'BranchOption',
      title: '请问您是否有样品可邮寄？',
      key: 'canOffer',
      options: [
        {
          label: '有',
          value: 'A',
          ...options[0]
        },
        {
          label: '没有',
          value: 'B',
          ...options[1]
        }
      ]
    }
  },
  1211: (prev: any, data: any) => {
    const next = data.groceriesQuestionInitialRequirement === 'A' ? 'B' : '2'
    return {
      type: 'InfoForm',
      title: '请上传您的参考链接或图片',
      items: [
        {
          type: 'input',
          label: '参考链接',
          key: 'productUrl'
        },
        {
          type: 'image',
          label: '参考图片',
          key: 'productImg'
        }
      ],
      next
    }
  }
}
